import type { ClassData, LibraryData } from '@/core/types/library.type'

function matchesTypeName(classData: ClassData, typeName: string): boolean {
  if (classData.name === typeName) return true

  const qualified =
    classData.namespace && classData.namespace !== '.' ? `${classData.namespace}.${classData.name}` : classData.name
  if (qualified === typeName) return true

  const suffix = typeName.includes('.') ? typeName.slice(typeName.lastIndexOf('.') + 1) : typeName
  return classData.name === suffix
}

function searchClassData(classData: ClassData, typeName: string): ClassData | undefined {
  if (matchesTypeName(classData, typeName)) return classData

  if (!classData.children) return undefined

  for (const child of Object.values(classData.children)) {
    const match = searchClassData(child, typeName)
    if (match) return match
  }

  return undefined
}

export function findClassDataByType(typeName: string, libraries: Record<string, LibraryData>): ClassData | undefined {
  const normalized = typeName.trim()
  if (!normalized) return undefined

  for (const lib of Object.values(libraries)) {
    if (!lib.classes) continue

    for (const cls of Object.values(lib.classes)) {
      const match = searchClassData(cls, normalized)
      if (match) return match
    }
  }

  return undefined
}
